export const eqeqeq = <T>(a: T, b: T): boolean => a === b;

export const deepEqual = <T>(a: T, b: T): boolean => JSON.stringify(a) === JSON.stringify(b);
